<template>
  <div class="vue-flow__node-default custom-node-padding if-node">
    <Handle type="target" :position="Position.Left" />
    <div class="node-type-tag">If</div>
    <div>{{ data.label !== undefined && data.label !== null && data.label !== '' ? data.label : 'If Condition' }}</div>
    <div v-if="conditionText !== ''" class="node-description">
      <div class="node-description-label">Condition</div>
      <div>{{ conditionText }}</div>
    </div>
    <Handle type="source" :position="Position.Right" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

function trimText(value) {
  if (typeof value === 'string') {
    return value.trim();
  }
  return '';
}

function getOperatorLabel(value) {
  if (value === 'notEquals') {
    return 'does not equal';
  }
  if (value === 'contains') {
    return 'contains';
  }
  if (value === 'notContains') {
    return 'does not contain';
  }
  if (value === 'greaterThan') {
    return 'is greater than';
  }
  if (value === 'greaterThanOrEqual') {
    return 'is greater than or equal to';
  }
  if (value === 'lessThan') {
    return 'is less than';
  }
  if (value === 'lessThanOrEqual') {
    return 'is less than or equal to';
  }
  if (value === 'exists') {
    return 'exists';
  }
  if (value === 'notExists') {
    return 'does not exist';
  }
  if (value === 'isTrue') {
    return 'is true';
  }
  if (value === 'isFalse') {
    return 'is false';
  }
  if (value === 'isEmpty') {
    return 'is empty';
  }
  if (value === 'isNotEmpty') {
    return 'is not empty';
  }
  return 'equals';
}

function shortenText(value) {
  const text = trimText(value);
  if (text.length <= 90) {
    return text;
  }
  return `${text.slice(0, 87)}...`;
}

const conditionText = computed(() => {
  const config = props.data !== null && props.data !== undefined && props.data.config !== undefined && props.data.config !== null ? props.data.config : {};
  const sourceKey = trimText(config.sourceKey);
  const left = trimText(config.left);
  const right = trimText(config.right);
  const subject = sourceKey.length > 0 ? sourceKey : left;
  const operator = getOperatorLabel(trimText(config.operator));
  if (subject.length === 0) {
    return '';
  }
  if (right.length === 0) {
    return shortenText(`${subject} ${operator}`);
  }
  return shortenText(`${subject} ${operator} ${right}`);
});
</script>

<style scoped>
.if-node {
  background-color: #fff7ed;
  border: 1px solid #fdba74;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  min-width: 260px;
  max-width: 380px;
}
.node-type-tag {
  background-color: #c2410c;
  color: #FFFFFF;
  font-size: 0.75rem;
  padding: 4px 12px;
  border-radius: 9999px;
  margin-bottom: 10px;
  display: inline-block;
  text-transform: uppercase;
  font-weight: 600;
  border: none;
}
.custom-node-padding {
  padding: 15px 20px;
}
.if-node > div:not(.node-type-tag):not(.node-description) {
  font-size: 0.9rem;
  color: #334155;
  text-align: center;
}
.node-description {
  font-size: 0.8rem;
  color: #4B5563;
  margin-top: 8px;
  white-space: pre-wrap;
  background-color: #ffedd5;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px dashed #fdba74;
  text-align: left;
  min-width: 220px;
}
.node-description-label {
  font-size: 0.66rem;
  color: #9a3412;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 3px;
}
</style>
